import { Select as AntSelect } from "antd";

export const Option = AntSelect.Option;
